/**
* Represent a task to be performed by a component
*/
export class MapTask {
  constructor(public action: any, public object?: any) {}
}